module.exports = __webpack_public_path__ + "img/1_001.38d73acf.webp";